"use client";

import * as React from "react";
import { Pagination } from "@/src/components";
import { ComponentPage } from "@/components/docs/component-page";

export default function DocsComponentsPagination() {
  const code = `import { Pagination } from "@/registry/new-york/ui/pagination";

export function PaginationDemo() {
  return (
    <Pagination
      pageNo={1}
      noOfPage={10}
      showPageNumber={true}
      onPageChange={(page) => console.log('Page changed to:', page)}
    />
  );
}`;

  const installCommand = `npx shadcn@latest add @bluecopa-ui/pagination`;

  return (
    <ComponentPage
      title="Pagination"
      description="Pagination with page size controls and smart page number display."
      preview={
        <Pagination
          pageNo={1}
          noOfPage={10}
          showPageNumber={true}
          onPageChange={() => {}}
        />
      }
      code={code}
      installCommand={installCommand}
      apiReference={{
        name: "PaginationProps",
        props: [
          {
            name: "pageNo",
            type: "number",
            description: "Current page number. Defaults to 1.",
          },
          {
            name: "noOfPage",
            type: "number",
            description: "Total number of pages. Defaults to 1.",
          },
          {
            name: "pageSize",
            type: "number",
            description: "Number of items per page. Defaults to 100.",
          },
          {
            name: "enablePageSize",
            type: "boolean",
            description: "Whether to show page size selector. Defaults to false.",
          },
          {
            name: "showPageNumber",
            type: "boolean",
            description: "Whether to show page numbers. Defaults to true.",
          },
          {
            name: "onPageChange",
            type: "(page: number) => void",
            description: "Callback fired when the page changes.",
          },
          {
            name: "onPageSizeChange",
            type: "(size: number) => void",
            description: "Callback fired when the page size changes.",
          },
        ],
      }}
    />
  );
}

